// Newest workflow run first. A queued run has no started_on yet, so created_on is the ordering key
// until it starts — both arrive on the run row as `startedAt`/`createdAt`.
const getWorkflowRunStartedAtMs = (run) => Date.parse(run?.startedAt || run?.createdAt || '') || 0;

const sortWorkflowRunsByStartedAt = (runs) => {
  return runs.slice().sort((a, b) => getWorkflowRunStartedAtMs(b) - getWorkflowRunStartedAtMs(a));
};

export default sortWorkflowRunsByStartedAt;
